import { Typography } from 'antd';
import React from 'react';
import { NotificationDrawerLabels as LABELS } from '../../components/modals/NotificationDrawer/NotificationDrawerConstants';
import { iconSelectorLandingZone } from '../../pages/Dashboard/DashboardCover/BuildDeploy/BuildDeployConstants';
import { getFormattedTimestamp } from '../../libs/helper/HelperFunctions';
import { LandingZoneStatus } from '../../libs/models/BuildDeployModels';
import { ILandingZoneNotification } from '../../libs/models/NotificationModels';
import './NotificationMobileDrawerCardStyles.less';

const getLandingZoneStatus = (landingZoneStatus: LandingZoneStatus | undefined) => {
  switch (landingZoneStatus) {
    case LandingZoneStatus.CREATED:
      return <Typography className="status-tag completed-tag">{landingZoneStatus}</Typography>;
    case LandingZoneStatus.IN_PROGRESS:
      return <Typography className="status-tag inprogress-tag">{landingZoneStatus}</Typography>;
    case LandingZoneStatus.ERROR:
      return <Typography className="status-tag error-tag">{landingZoneStatus}</Typography>;
    default:
      return <Typography className="status-tag inprogress-tag">{landingZoneStatus}</Typography>;
  }
};

const NotificationsMobileDrawerCard = ({
  dateTime,
  status,
  cloudProvider,
  landingZoneName,
  account,
  project,
  username,
}: ILandingZoneNotification) => {
  return (
    <div className="notification-card boxShadow">
      <div className="flex-row-space-between">
        <div>{getFormattedTimestamp(dateTime)}</div>
        <div className="user-table-status-column">{getLandingZoneStatus(status)}</div>
      </div>
      <div className="flex-row">
        <img src={iconSelectorLandingZone(cloudProvider)} alt="cloud-icon" />
        <div className="flex-column cloud-title-box">
          <Typography className="notification-row-label">{LABELS.environment}</Typography>
          <Typography className="notification-row-value">{landingZoneName}</Typography>
        </div>
      </div>
      <div className="flex-row-space-between">
        <div className="flex-column border-right-dashed notice-board">
          <div className="notification-row-label">{LABELS.account}</div>
          <div className="notification-row-value">{account}</div>
        </div>
        <div className="flex-column border-right-dashed notice-board">
          <div className="notification-row-label">{LABELS.project}</div>
          <div className="notification-row-value">{project}</div>
        </div>
        <div className="flex-column notice-board">
          <div className="notification-row-label">{LABELS.username}</div>
          <div className="notification-row-value">{username}</div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsMobileDrawerCard;
